'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.securityGroup.configure.kubernetes.backend', [ ])
  .controller('kubernetesSecurityGroupBackendController', function() {
    this.maxPort = 65535;
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/kubernetes/src/securityGroup/configure/wizard/backend.controller.js